import { ElementRef, Injectable } from '@angular/core';

@Injectable()
export class WrapperService {
  public wrapperElementRef: ElementRef;
}
